<div class="cc-header__brandmark">
  <ng-container [ngSwitch]="true">
    <ng-container *ngSwitchCase="!!url">
      <div class="cc-brand-link cc-display--flex">
        <a class="cc-header__star" href="{{ url }}">
          <img
            src="https://assets.oneweb.mercedes-benz.com/global/1.16.0/images/svg/MB-star_n_web.svg"
            alt="Mercedes-Benz"
            loading="lazy"
            width="64"
            height="64"
          />
        </a>
      </div>
      <div class="cc-header__claim" *ngIf="claim">
        <a href="{{ url }}">
          <img [src]="claim" alt="Mercedes-Benz" loading="lazy" width="112" height="28" />
        </a>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="!url">
      <div class="cc-brand-link cc-display--flex">
        <span class="cc-header__star">
          <img
            src="https://assets.oneweb.mercedes-benz.com/global/1.16.0/images/svg/MB-star_n_web.svg"
            alt="Mercedes-Benz"
            loading="lazy"
            width="64"
            height="64"
          />
        </span>
      </div>
      <div class="cc-header__claim" *ngIf="claim">
        <img [src]="claim" alt="Mercedes-Benz" loading="lazy" width="112" height="28" />
      </div>
    </ng-container>
  </ng-container>
</div>
